<template>
	<div
		class="container__crudtable"
		data-testid="table-component"
	>
		<div class="container__crudtable__table">
			<div
				v-if="data.length > 0"
				class="container__crudtable__table__mobile"
			>
				<MobileTable
					v-for="(dataObject, key) in data"
					:key="key"
					:headers="headers"
					:data-object="dataObject"
					:table-configuration="tableConfiguration"
				/>
			</div>
			<div
				v-else
				class="container__crudtable__table__mobile container__crudtable__empty"
			>
				<p>{{ tableConfiguration.statusTable }}</p>
			</div>
			<div class="container__crudtable__table__normal">
				<NormalTable
					:report-mode="reportMode"
					:headers="headers"
					:data="data"
					:table-configuration="tableConfiguration"
					:mostrar-btn-editar="mostrarBtnEditar"
					:show-sort-options="true"
					:is-official="isOfficial"
					@sortConfig="$emit('sortConfig', $event)"
					@sortConfigDate="$emit('sortConfigDate', $event)"
				>
					<template #action-button="dataObject">
						<slot
							name="outer-action-button"
							v-bind="dataObject"
						/>
					</template>
				</NormalTable>
			</div>
		</div>
	</div>
</template>

<script>
import MobileTable from './MobileTable/MobileTable'
import NormalTable from './NormalTable/NormalTable'
export default {
	components: { MobileTable, NormalTable },
	props: {
		showSortOptions: { type: Boolean, default: false },
		headers: { type: Array, required: true },
		mostrarBtnEditar: { type: Boolean, default: true },
		isOS: { type: Boolean, default: false },
		data: { type: Array, degfault: () => [] },
		tableConfiguration: {
			type: Object,
			default: () => ({
				statusTable: this.$t('noRecordFound'),
			}),
		},
		showEditModelForm: Function,
		showResumoModelForm: Function,
		reportMode: {
			type: Boolean,
			default: false,
		},
		isOfficial: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<style scoped>
.container__crudtable {
	width: 100%;
}

.container__crudtable__table__normal {
	display: none;
}

.container__crudtable__empty {
	display: flex;
	justify-content: center;
	font-size: 0.75rem;
	padding: 1rem;
}

@media screen and (min-width: 992px) {
	.container__crudtable__table__mobile {
		display: none;
	}

	.container__crudtable__table__normal {
		display: block;
	}
}
</style>
